import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

import {
  AddInternalNotificationRecipientPayload,
  InternalNotificationRecipient,
  InternalNotificationRecipientOptions,
  InternalNotificationsResponse,
} from '../../../interfaces/internal-notification.interface';
import { InternalNotificationsApiService } from './internal-notifications-api.service';

/** Cliente de la API de Comunicación interna (`/internal-notifications`). */
@Injectable()
export class InternalNotificationsHttpService extends InternalNotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiGateway}internal-notifications`;

  getNotifications(): Observable<InternalNotificationsResponse> {
    return this.http.get<InternalNotificationsResponse>(this.baseUrl);
  }

  getRecipientOptions(): Observable<InternalNotificationRecipientOptions> {
    return this.http.get<InternalNotificationRecipientOptions>(`${this.baseUrl}/recipient-options`);
  }

  addRecipient(
    notificationId: number,
    payload: AddInternalNotificationRecipientPayload,
  ): Observable<InternalNotificationRecipient> {
    return this.http.post<InternalNotificationRecipient>(
      `${this.baseUrl}/${notificationId}/recipients`,
      payload,
    );
  }

  removeRecipient(
    notificationId: number,
    recipientId: number,
  ): Observable<InternalNotificationRecipient> {
    return this.http.delete<InternalNotificationRecipient>(
      `${this.baseUrl}/${notificationId}/recipients/${recipientId}`,
    );
  }
}
